import mutations from "@/store/mutations/superPayMutation";
import actions from "@/store/actions/superPayAction";
import getters from "@/store/getters/superPayGetter";
/**
 * [GX] Supreme
 */
export default {
  state: {
    superPayShowEnable: false, //是否可以显示superpay等 的基本条件
    superPayConfigInterfaceEnable: null, //拉取的配置接口是否可用
    superPayWayInterfaceEnable: null, //支付是否可用
    superPayAppConfig: null, //所有初始化都为null,证明没有执行判断过
    superPayAppInstalled: null //是否安装过了
  },
  mutations,
  actions,
  getters
};
